module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.getTitle,
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      },
      "close": _vm.closeModal
    }
  }, [_c('el-row', {
    staticClass: "margin-bottom-30"
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.gridData,
      "height": "300",
      "stripe": ""
    }
  }, [_vm._l((_vm._columnsToShow), function(item) {
    return _c('el-table-column', {
      attrs: {
        "label": item.label
      },
      inlineTemplate: {
        render: function() {
          var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
            return _c('SgsRender', {
              attrs: {
                "type": item.attr.type,
                "moduleType": "list",
                "attr": item.attr,
                "fieldValue": _vm.row[item.value],
                "formIdentifier": _vm.formIdentifier
              }
            })
          
        },
        staticRenderFns: []
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('el-button', {
            attrs: {
              "size": "mini",
              "type": "primary"
            },
            on: {
              "click": function($event) {
                $event.preventDefault();
                return _vm.selectRow(_vm.row)
              }
            }
          }, [_vm._v("\n              Selecione\n            ")])
        
      },
      staticRenderFns: []
    }
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-964bde9a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utils/sgs/AutoComplete.vue
// module id = 953
// module chunks = 2